import { render, staticRenderFns } from "./MdPainAssessmentList.vue?vue&type=template&id=566440a4&scoped=true&"
import script from "./MdPainAssessmentList.vue?vue&type=script&lang=js&"
export * from "./MdPainAssessmentList.vue?vue&type=script&lang=js&"
import style0 from "./MdPainAssessmentList.vue?vue&type=style&index=0&id=566440a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566440a4",
  null
  
)

export default component.exports